import { registerServiceWorker } from "@accessinformatica/service-worker";
import { detect } from "detect-browser";
import { createRoot } from "react-dom/client";
import "regenerator-runtime/runtime";
import packagejson from "../package.json";
import { signoutUser } from "./actions/login";
import App from "./App";
import UnsupportedBrowser from "./components/ui/unsupportedBrowser/unsupportedBrowser";
import UnsupportedVersionBrowser from "./components/ui/unsupportedBrowser/unsupportedVersionBrowser";
import { persistor, store } from "./store";

const browser = detect();
const browserVersion = parseInt(browser.version);

var browserOk = true;
var friendlyBrowserName;
var browserMinVersion;

// Crear la raíz de React una sola vez
const container = document.getElementById("root");
const root = createRoot(container);

const AppWrapper = () => {
  if (browser.name === "ie") {
    return <UnsupportedBrowser />;
  } else if (browserVersion >= browserMinVersion && browserOk) {
    return <App />;
  } else {
    return (
      <UnsupportedVersionBrowser
        browser={browser.name}
        browserName={friendlyBrowserName}
        version={browser.version}
        minVersion={browserMinVersion}
      />
    );
  }
};

const checkUnsupportedBrowser = () => {
  root.render(<AppWrapper />);
};

switch (browser && browser.name) {
  case "chrome":
    browserMinVersion = 57;
    friendlyBrowserName = "Google Chrome";
    break;

  case "firefox":
    browserMinVersion = 50;
    friendlyBrowserName = "Mozilla Firefox";
    break;

  case "opera":
    browserMinVersion = 50;
    friendlyBrowserName = "Opera";
    break;

  case "edge-chromium":
    browserMinVersion = 86;
    friendlyBrowserName = "Microsoft Edge (Chromium)";
    break;

  case "safari":
    friendlyBrowserName = "Safari";
    browserMinVersion = 12;
    break;

  case "samsung":
    friendlyBrowserName = "Samsung Internet";
    browserMinVersion = 8;
    break;

  case "ios":
    friendlyBrowserName = "Safari";
    browserMinVersion = 12;
    break;

  case "edge":
    friendlyBrowserName = "Microsoft Edge";
    browserOk = false;
    break;

  default:
    browserOk = false;
    break;
}

checkUnsupportedBrowser();

registerServiceWorker({
  store,
  version: packagejson.version,
  swPath: `${CONFIG.path}/service-worker.js?v=2`,
  persistor,
  onControllerChange: () => {
    store.dispatch(signoutUser());
    return Promise.resolve();
  },
});